import axios from "axios";
import {
  getToken,
  removeToken,
  // setToken,
  getRefresh,
  removeRefresh,
  getUserData
} from "./auth";
import store from "../store/store";
import AppConfig from "./vue-axios.config";

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";

const service = axios.create({
  baseURL: AppConfig.backendPath
});

service.interceptors.request.use(
  config => {
    config.withCredentials = true;
    if (getToken()) {
      let permissions = JSON.parse(localStorage.getItem("userInfo"))
      config.headers["Authorization"] = "Bearer " + getToken();
      config.headers["Accept"] = "application/json";
      config.headers['Permissions'] = permissions.permissions
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.message === "Unauthenticated") {
      window.location = "/pages/login";
    }
    return response;
  },
  error => {
    const originalRequest = error.config;
    // console.log(originalRequest.url)
    if (
      error.response.status === 401 &&
      originalRequest.url === "/api/auth/token/refresh/"
    ) {
      removeToken();
      removeRefresh();
      window.location = "/pages/login";
    } else if (
      error.response.status === 401 &&
      error.response.statusText === "Unauthorized" &&
      getRefresh()
    ) {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;

        store
          .dispatch("auth/fetchAccessToken")
          .then(res => {
            if (res.data.access) {
              isAlreadyFetchingAccessToken = false;
              onAccessTokenFetched(res.data.access);
            } else {
              removeToken();
              removeRefresh();
              window.location = "/pages/login";
            }
          })
          .catch(() => {
            removeToken();
            window.location = "/pages/login";
          });
      }
      const retryOriginalRequest = new Promise(resolve => {
        addSubscriber(access_token => {
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          resolve(axios(originalRequest));
        });
      });

      return retryOriginalRequest;
    } else if (error.response.status === 405) {
      window.location = "/page-405";
    }
    return Promise.reject(error);
  }
);

export default service;
